<template>
  <b-tab :title="$t('common.surgeries')" active>
    <div>
      <b-row>
        <b-col cols="3">
          <AutoComplete
            :label="$t('common.filter-by-surgery-name')"
            v-model="surgery_id"
            :serializer="(val) => val"
            param-query="search"
            endpoint="surgery"
            text-title="title"
            :placeholder="$t('common.filter-by-surgery-name')"
          />
        </b-col>
        <b-col cols="3">
          <b-form-group
            :label="$t('common.filter-by-patient-name')"
            label-for="Name"
          >
            <b-form-input
              id="Name"
              v-model="patientName"
              :placeholder="$t('common.filter-by-patient-name')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            :label="$t('common.filter-by-surgery-price')"
            label-for="Name"
          >
            <b-form-input
              id="Name"
              type="number"
              v-model="surgeyPrice"
              :placeholder="$t('common.filter-by-surgery-price')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            :label="$t('common.filter-by-final-result')"
            label-for="final_result"
          >
            <v-select
              id="final_result"
              v-model="final_result"
              :options="final_result_options"
              :placeholder="$t('common.filter-by-final-result')"
              :reduce="(option) => option.value"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group :label="$t('common.from-date')" label-for="from_date">
            <datepicker
              id="surgery_date"
              v-model="from"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group :label="$t('common.to-date')" label-for="to_date">
            <datepicker
              id="surgery_date"
              v-model="to"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
        <b-col style="margin-top: 20px" cols="3">
          <b-button
            variant="primary"
            class="button-preview"
            @click="getSurgeryList"
          >
            {{ $t("common.export-excel") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-tab>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
  BTab,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import { ClockIcon } from "vue-feather-icons";
import AutoComplete from "@/components/common/AutoComplete.vue";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    ClockIcon,
    BTab,
    BTabs,
    AutoComplete,
  },
  data() {
    return {
      take: 100000000,
      loading: true,
      dataCount: 0,
      data: [],
      surgeryName: "",
      surgery_id: null,
      surgery_date: null,
      patientName: "",
      page: 1,
      from: null,
      to: null,
      surgeyPrice: null,
      final_result: null,
      final_result_options: [
        { label: this.$t("common.success-operation"), value: "success" },
        { label: this.$t("common.failed-operation"), value: "failed" },
      ],
    };
  },
  mounted() {},
  watch: {},
  methods: {
    formatDate(date) {
      return new Date(date).toISOString().split("T")[0];
    },
    async getSurgeryList() {
      this.loading = true;
      let url = `/patient-surgery?page=${this.page}&take=${this.take}&sort=-surgery_date_time&include=surgery`;

      if (this.patientName) {
        url += `&filter[patientCard.patient.name]=${this.patientName}`;
      }
      if (this.surgeyPrice) {
        url += `&filter[price]=${this.surgeyPrice}`;
      }
      if (this.from) {
        console.log(this.from);
        this.from = this.formatDate(this.from);
        url += `&from=${this.from}`;
      }
      if (this.to) {
        console.log(this.to);
        this.to = this.formatDate(this.to);
        url += `&to=${this.to}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id.id}`;
      }
      if (this.final_result) {
        url += `&filter[final_result]=${this.final_result}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      console.log("ahmedddd surgery", this.all_data);
      this.data = this.all_data.data;
      this.loading = false;

      // Call the export method after setting the data
      this.exportToExcel();
    },

    async exportToExcel() {
      try {
        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Surgeries");

        // Define worksheet columns based on your data structure
        worksheet.columns = [
          { header: "اسم المريض", key: "patient_name", width: 15 },
          { header: "الجنس", key: "gender", width: 5 },
          { header: "العمر", key: "age", width: 5 },
          { header: "نوع العملية", key: "surgery_title", width: 20 },
          { header: "الجراح", key: "doctor_name", width: 30 },
          { header: "المخدر", key: "anesthesia", width: 15 },
          { header: "وقت العملية", key: "surgery_date_time", width: 18 },
          { header: "النتيجة", key: "final_result", width: 15 },
          // Add more columns as needed based on your data
        ];

        // Add rows to the worksheet from this.data
        this.data.forEach((item) => {
          const doctorName = this.getDoctorName(item.doctors_prices.items);
          console.log("doctorName", doctorName);
          worksheet.addRow({
            patient_name: item.patient_card.patient.name,
            surgery_title: item.surgery.title,
            doctor_name: doctorName.surgeon,
            anesthesia: doctorName.anesthetist,
            gender: item.patient_card.patient.gender,
            age: this.getAge(item.patient_card.patient.birth_date),
            surgery_date_time: item.surgery_date_time,
            final_result: item.final_result !== null ? (item.final_result === "success" ? "العملية ناجحة" : "العملية فشلت") : "",
          });
        });

        // Write the workbook to a buffer and trigger a download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Build the file name dynamically using the filters if they exist
        const filters = [];

        if (this.surgery_id) {
          filters.push(`surgery-${this.surgery_id.title}`);
        }
        if (this.patientName && this.patientName.trim() !== "") {
          filters.push(`patient-${this.patientName.trim()}`);
        }
        if (this.surgeyPrice) {
          filters.push(`price-${this.surgeyPrice}`);
        }
        if (this.final_result) {
          filters.push(`result-${this.final_result}`);
        }
        if (this.from) {
          // Assuming formatDate formats date as YYYY-MM-DD
          filters.push(`from-${this.formatDate(this.from)}`);
        }
        if (this.to) {
          filters.push(`to-${this.formatDate(this.to)}`);
        }

        // If no filters are selected, display "all"
        const filtersPart = filters.length ? filters.join("_") : "all";

        // Build the final filename
        const fileName = `Surgeries_${filtersPart}.xlsx`;

        // Save the file using file-saver
        saveAs(blob, fileName);
      } catch (error) {
        console.error("Error exporting Excel file:", error);
      }
    },
    // getFinalResult(final_result, gender) {
    //   if (final_result === "success" && gender === "male") {
    //     return "خرج متحسن";
    //   } else if (final_result === "success" && gender === "female") {
    //     return "أنثى";
    //   }
    // },
    getDoctorName(doctors) {
      // Filter and map surgeon names (including null types)
      const surgeons = doctors
        .filter((doctor) => doctor.type === "surgeon" || doctor.type === null)
        .map((doctor) => doctor.doctor.name)
        .join(", ");

      // Filter and map anesthetist names
      const anesthetists = doctors
        .filter((doctor) => doctor.type === "anesthetist")
        .map((doctor) => doctor.doctor.name)
        .join(", ");

      return {
        surgeon: surgeons || "", // Return empty string if no surgeons
        anesthetist: anesthetists || "", // Return empty string if no anesthetists
      };
    },
    getAge(birthDate) {
      const today = new Date();
      const birthDateObj = new Date(birthDate);
      let age = today.getFullYear() - birthDateObj.getFullYear();
      const monthDiff = today.getMonth() - birthDateObj.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
      ) {
        age--;
      }
      return age;
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
